import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'
export function selectMeters(id) {
  return request({
    url: cmsServerContext + '/Meter/selectMeters/' + id,
    method: 'get'
  })
}
export function selectMeterById(myPage) {
  return request({
    url: cmsServerContext + '/Meter/selectMeterById',
    method: 'post',
    data: myPage
  })
}
export function selectEnableMeter() {
  return request({
    url: cmsServerContext + '/Meter/selectEnableMeter',
    method: 'get'
  })
}

export function addMeter(meter) {
  return request({
    url: cmsServerContext + '/Meter/addMeter',
    method: 'post',
    data: meter
  })
}

export function list(condition) {
  return request({
    url: cmsServerContext + '/Meter/list',
    method: 'post',
    data: condition
  })
}
export function getMapping(ids) {
  return request({
    url: cmsServerContext + '/Meter/getMapping/' + ids,
    method: 'post'
  })
}
export function selectMeterByIds(ids) {
  return request({
    url: cmsServerContext + '/Meter/selectMeterByIds',
    method: 'post',
    data:ids
  })
}
export function meterMoneyData(energyDataQueryParam) {
  return request({
    url: cmsServerContext + '/meterMoneyData/meterMoney',
    method: 'post',
    data: energyDataQueryParam
  })
}

/**
 * 查询综合统计报表数据表格
 * @param meterIds
 * @param startTime
 * @param endTime
 * @param timeGranularity
 * @param customerId
 */
export function syntheticReport(meterIds, startTime, endTime, timeGranularity, customerId) {
  return request({
    url: cmsServerContext + '/Meter/syntheticReport',
    method: 'post',
    data: { meterIds: meterIds, startTime: startTime, endTime: endTime, timeGranularity: timeGranularity,customerId:customerId }
  })
}

/**
 * 根据用户id查询仪表
 * @param customerId
 * @param customerUserId
 */
export function getMetersByUser(customerId,customerUserId) {
  return request({
    url: cmsServerContext + '/Meter/getMetersByUser/' + customerId+"/"+customerUserId,
    method: 'get'
  })
}

export function deleteByCodes(meterCodes) {
  return request({
    url: cmsServerContext + '/Meter/delete',
    method: 'post',
    data: meterCodes
  })
}

export function saveMeter(meter) {
  return request({
    url: cmsServerContext + '/Meter/save',
    method: 'post',
    data: meter
  })
}

export function batchSendCmd(OperationCmd) {
  return request({
    url: cmsServerContext + '/batchConfig/batchConfigMeter',
    method: 'post',
    data: OperationCmd
  })
}

export function reSendCmd(record) {
  return request({
    url: cmsServerContext + '/batchConfig/reConfigMeter',
    method: 'post',
    data: record
  })
}

